module.exports = __webpack_public_path__ + "static/media/Icon-01@2x.9e7e9a4f.png";